// @module BTM.ChangesRequestedbyAlight.ChangesRequestedbyAlight
define('BTM.ChangesRequestedbyAlight.ChangesRequestedbyAlight.View'
,	[
		'btm_changesrequestedbyalight_changesrequestedbyalight.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_changesrequestedbyalight_changesrequestedbyalight_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.ChangesRequestedbyAlight.ChangesRequestedbyAlight.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_changesrequestedbyalight_changesrequestedbyalight_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ChangesRequestedbyAlight.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.ChangesRequestedbyAlight.ChangesRequestedbyAlight.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.ChangesRequestedbyAlight.ChangesRequestedbyAlight.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
